export const BORROWER_ANALYTIC_EVENTS = {
  BORROWER_CREATED: "BORROWER_CREATED",
  BORROWER_UPDATED: "BORROWER_UPDATED",
  BORROWER_DELETED: "BORROWER_DELETED",
};